import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import _ from 'lodash';
import socket from '../../../../context/socket';
import YearSelect from '../../StartedYear/year';
import { fetchClientData } from '../../../../redux/client/clientSlice';
import { useDispatch } from 'react-redux';
import api from '../../../../utils/api';

// Debounce function to delay API calls
function debounce(func, wait) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
}

const EmergencyFundData = ({ roomId, card_id, planYourGoals }) => {
  const dispatch = useDispatch();
  const [selectedCard, setSelectedCard] = useState(null);
  const [emergencyFundInputData, setEmergencyFundInputData] = useState({
    amount: "",
    goalYear: "",
    startYear: new Date().getFullYear().toString(),
  });

  useEffect(() => {
    if (!planYourGoals || !card_id) return;

    const card = planYourGoals.find((item) => item._id === card_id);
    setSelectedCard(card);

    if (card?.action_data?.[0]) {
      const {
        amount = "",
        goalYear = "",
        startYear = new Date().getFullYear().toString(), // fallback if missing
      } = card.action_data[0];

      setEmergencyFundInputData({
        amount,
        goalYear,
        startYear,
      });
    } else {
      // fallback if action_data missing
      setEmergencyFundInputData((prev) => ({
        ...prev,
        startYear: new Date().getFullYear().toString(),
      }));
    }
  }, [planYourGoals, card_id]);


  // Function to save data via API
  const saveData = async (updatedData) => {
    // Check if all required fields are filled
    const allFieldsFilled =
      updatedData.amount !== "" &&
      updatedData.goalYear !== "" &&
      // updatedData.priceAppreciation !== "" &&
      // updatedData.goalYear !== "" &&
      updatedData.startYear !== "";

    // Add the status based on field values
    // const dataWithStatus = {
    //   ...updatedData,
    //   status: allFieldsFilled ? 1 : 0, // Status is 1 if all fields are filled, otherwise 0
    // };

    const newStatus = allFieldsFilled ? 1 : 0;
      const prevCreatedAt = selectedCard?.created_at;

      const dataWithStatus = {
        ...updatedData,
        status: newStatus,
      };

      const payload = {
        _id: roomId,
        dream_id: card_id,
        action_data: [dataWithStatus],
        status: newStatus,
      };

      // ✅ Add created_at ONLY ONCE at ROOT
      if (newStatus === 1 && !prevCreatedAt) {
        payload.created_at = new Date().toISOString();
      }

    try {
      const response = await api.post(`advisor/save_goal_data`,payload);
      dispatch(fetchClientData(roomId));

      console.log("Data saved successfully:", response.data);
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };


  // Debounced save function
  const debouncedSaveData = useCallback(
    debounce((updatedData) => saveData(updatedData), 500),
    [selectedCard]
  );

  // Handle input changes
  const handleEmergencyFundInputChange = (field, value) => {
    const updatedData = {
      ...emergencyFundInputData,
      [field]: value,
    };
    setEmergencyFundInputData(updatedData);

    // Trigger the debounced save function
    debouncedSaveData(updatedData);
  };

  // Joining socket room
  useEffect(() => {
    socket.emit("join", roomId);
  }, [roomId]);

  const debouncedEmitMessage = useCallback(
    _.debounce(() => {
      console.log("emitted data", selectedCard, emergencyFundInputData,);
      socket.emit("message", {
        room: roomId,
        data: {
          selectedCard,
          emergencyFundInputData,
        },
      });
    }, 300),
    [
      selectedCard,
      roomId,
      emergencyFundInputData,

    ]
  );

  useEffect(() => {
    debouncedEmitMessage();
  }, [
    selectedCard,
    debouncedEmitMessage,
    emergencyFundInputData,
  ]);

  return (
    <>
      <div className="row ps-3">
        <div className="col-md-1 col-2 heartwidth">
          <img src="assets/images/heart.png" alt="" />
        </div>
        <div className="col-md-10 col-10">
          <p className="fs-21 lh-sm">
            I would like to be well prepared for emergencies with an easily accessible fund of at least{" "}
            <span className="clrgreen fw-semibold">
              {" "}₹{" "}
              <input
                type="number"
                style={{
                  border: "none",
                  borderBottom: "1px solid green",
                  width: `${emergencyFundInputData.amount?.length + 3}ch`,
                  paddingLeft: "1rem",
                  minWidth: "7ch",
                }}
                value={emergencyFundInputData.amount}
                // onChange={(e) =>
                //   handleEmergencyFundInputChange("amount", e.target.value)
                // }
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || Number(value) >= 0) {
                    handleEmergencyFundInputChange("amount", value)
                  }
                }}
                className="clrgreen fw-bold ps-3 moinput"
                placeholder="0"
              />
            </span>{" "}
            Ideally, I would like to save up this amount by{" "}
            <input
              type="number"
              style={{
                border: "none",
                borderBottom: "1px solid green",
                width: `${emergencyFundInputData.goalYear?.length + 3}ch`,
                paddingLeft: "1rem",
                minWidth: "7ch",
              }}
              value={emergencyFundInputData.goalYear}
              // onChange={(e) =>
              //   handleEmergencyFundInputChange("goalYear", e.target.value)
              // }
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || Number(value) >= 0) {
                  handleEmergencyFundInputChange("goalYear", value)
                }
              }}
              className="clrgreen fw-bold ps-3 moinput"
              placeholder="Year"
            />
          </p>
        </div>
      </div>

      {/* <div className="row ps-3">
        <div className="col-md-1 col-2 heartwidth">
          <img src="assets/images/heart.png" alt="" />
        </div>
        <div className="col-md-9 col-10">
          <p className="fs-21 lh-sm">
            I expect that its price will appreciate{" "}
            <span className="clrgreen fw-semibold">
              <input
                type="number"
                style={{
                  border: "none",
                  borderBottom: "1px solid green",
                  width: `${emergencyFundInputData.priceAppreciation?.length + 3}ch`,
                  paddingLeft: "1rem",
                  minWidth: "7ch",
                }}
                value={emergencyFundInputData.priceAppreciation}
                onChange={(e) =>
                  handleEmergencyFundInputChange("priceAppreciation", e.target.value)
                }
                className="clrgreen fw-bold ps-3 moinput"
                placeholder="0"
              />
            </span>{" "}
            % from now till Year{" "}
            <input
              type="number"
              style={{
                border: "none",
                borderBottom: "1px solid green",
                width: `${emergencyFundInputData.goalYear?.length + 3}ch`,
                paddingLeft: "1rem",
                minWidth: "7ch",
              }}
              value={emergencyFundInputData.goalYear}
              onChange={(e) =>
                handleEmergencyFundInputChange("goalYear", e.target.value)
              }
              className="clrgreen fw-bold ps-3 moinput"
              placeholder="Year"
            />
          </p>
        </div>
      </div> */}

      {/* <div className="row ps-3">
        <div className="col-md-1 col-2 heartwidth">
          <img src="assets/images/heart.png" alt="" />
        </div>
        <div className="col-md-9 col-10">
          <p className="fs-21 lh-sm">
            Start Year{" "}
            <span className="clrgreen fw-semibold">
              <select
                style={{
                  border: "none",
                  borderBottom: "1px solid green",
                  width: `${emergencyFundInputData.startYear?.length + 3}ch`,
                  paddingLeft: "1rem",
                  minWidth: "8ch",
                }}
                value={emergencyFundInputData.startYear}
                onChange={(e) =>
                  handleEmergencyFundInputChange("startYear", e.target.value)
                }
                className="clrgreen fw-bold ps-3 moinput"
              >
                <option value="">select</option>
                <option value="2024">2024</option>
                <option value="2025">2025</option>
              </select>
            </span>{" "}
          </p>
        </div>
      </div> */}

      <div className="row ps-3 align-items-center">
        <div className="col-md-1 col-2 heartwidth">
          <img src="assets/images/heart.png" alt="" />
        </div>

        <div className="col-md-9 col-10 d-flex align-items-center">
          <p className="fs-21 lh-sm me-2 pt-3">Start Year: </p>
          <div style={{ minWidth: "120px" }}>
            <YearSelect
              value={emergencyFundInputData.startYear}
              onChange={(val) =>
                handleEmergencyFundInputChange("startYear", val)
              }
              recentYear={new Date().getFullYear()}
            />
          </div>
        </div>
      </div>

    </>
  );
};

export default EmergencyFundData;
